const SHORTCUT_KEYS = {
  CALL_CURRENT_QUEUE: "f8",
  CALL_NEXT_QUEUE: "f9",
};

export { SHORTCUT_KEYS };
